import {ResponseType} from 'axios';
import {ApiServer, DEFAULT_API_SERVER} from '../constants/config.model';

interface Headers {
  [key: string]: string;
}

export class HttpWrapperOptions {
  errors: boolean;
  ignore401: boolean;
  wait: boolean;
  waitTimeout: number;
  timeout: number;
  extraTries: number;
  cacheQueryParams?: string;
  responseType?: ResponseType;
  requestSequenceIdentificator?: string;
  throwException: boolean;
  headers?: Headers;
  ignoreDisplayError?: boolean;
  apiServer: ApiServer;

  constructor() {
    this.errors = true;
    this.ignore401 = false;
    this.wait = false;
    this.extraTries = 2;
    this.waitTimeout = 300;
    this.timeout = 10000;
    this.cacheQueryParams = undefined;
    this.responseType = 'json';
    this.requestSequenceIdentificator = undefined;
    this.throwException = false;
    this.headers = undefined;
    this.ignoreDisplayError = false;
    this.apiServer = DEFAULT_API_SERVER;
  }

  public IgnoreDisplayError(_ignore: boolean): HttpWrapperOptions {
    this.ignoreDisplayError = _ignore;
    return this;
  }
  public Errors(_errors: boolean): HttpWrapperOptions {
    this.errors = _errors;
    return this;
  }

  public Ignore401(_ignore401: boolean): HttpWrapperOptions {
    this.ignore401 = _ignore401;
    return this;
  }

  public Wait(_wait: boolean): HttpWrapperOptions {
    this.wait = _wait;
    return this;
  }

  public Timeout(_timeout: number): HttpWrapperOptions {
    this.timeout = _timeout;
    return this;
  }

  public ThrowException(_throwException: boolean): HttpWrapperOptions {
    this.throwException = _throwException;
    return this;
  }

  public WaitTimeout(_waitTimeout: number): HttpWrapperOptions {
    this.waitTimeout = _waitTimeout;
    return this;
  }

  public ExtraTries(_extraTries: number): HttpWrapperOptions {
    this.extraTries = _extraTries;
    return this;
  }

  public CacheQueryParams(_cacheQueryParams: string): HttpWrapperOptions {
    this.cacheQueryParams = _cacheQueryParams;
    return this;
  }
  public ResponseType(_responseType: ResponseType): HttpWrapperOptions {
    this.responseType = _responseType;
    return this;
  }
  public RequestSequenceIdentificator(_requestSequenceIdentificator: string): HttpWrapperOptions {
    this.requestSequenceIdentificator = _requestSequenceIdentificator;
    return this;
  }
  public Headers(_headers: Headers): HttpWrapperOptions {
    this.headers = _headers;
    return this;
  }
}
